import Bugsnag from '@bugsnag/js'
import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import { pathStr } from 'utils/fp'
import { trackEvent } from 'utils/tracking'
import { createClusterUpgradeJobBody } from './action-helpers'

const { kubernetes } = ApiClient.getInstance()

export const clusterUpgradeJobActions = ActionsSet.make<DataKeys.KaapiClusterUpgradeJobs>({
  uniqueIdentifier: 'metadata.name',
  entityName: entityNamesByKey[DataKeys.KaapiClusterUpgradeJobs],
  cacheKey: DataKeys.KaapiClusterUpgradeJobs,
})

export const listKaapiClusterUpgradeJobs = clusterUpgradeJobActions.add(
  new ListAction<DataKeys.KaapiClusterUpgradeJobs>(async () => {
    Bugsnag.leaveBreadcrumb('Attempting to get all Cluster Upgrade Jobs')
    return kubernetes.getAllCustomResources(DataKeys.KaapiClusterUpgradeJobs)
  }),
)

export const createKaapiClusterUpgradeJob = clusterUpgradeJobActions.add(
  new CreateAction<
    DataKeys.KaapiClusterUpgradeJobs,
    {
      namespace: string
      clusterName: string
      nodeGroups?: any[]
      upgradeJobs?: any[]
      targetVersion: string
      sourceVersion: string
      upgradeImageName: string
      // addons?: any[]
    }
  >(async (params) => {
    Bugsnag.leaveBreadcrumb('Attempting to create Cluster Upgrade Job', params)
    const body = createClusterUpgradeJobBody(params)
    const resource = await kubernetes.createCustomResource({
      type: DataKeys.KaapiClusterUpgradeJobs,
      body,
    })
    trackEvent('Create Cluster Update Job', {
      name: pathStr('metadata.name', resource),
      namespace: pathStr('metadata.namespace', resource),
      clusterName: pathStr('spec.clusterName', resource),
    })
    await kubernetes.getAllCustomResources(DataKeys.KaapiClusterUpgradeJobs)
    return resource
  }),
)
